export default {
	logo: 'F7',
	navBar: {
		active: '0',
		list:[{
				name: '首页',
				subActive: '0',
				submenu: [{
						icon: "el-icon-s-home",
						name: "后台首页",
						pathname:'index'
					},
					{
						icon: "el-icon-s-fold",
						name: "相册管理",
						pathname:'image'
					},
					{
						icon: "el-icon-s-fold",
						name: "商品列表",
						pathname:'shop_goods_list'
					}
				]
			},
			{
				name: '商品',
				subActive: '0',
				submenu: [{
					icon: "el-icon-s-fold",
					name: "分类管理",
					pathname:'shop_category'
				},
				{
					icon: "el-icon-s-fold",
					name: "商品列表",
					pathname:'shop_goods_list'
				}
				]
			},
			{
				name: '订单',
				subActive: '0',
				submenu: []
			},
			{
				name: '会员',
				subActive: '0',
				submenu: []
			},
			{
				name: '设置',
				subActive: '0',
				submenu: [
					{
						icon: "el-icon-s-fold",
						name: "基础设置",
						pathname:'set_base'
					},
					{
						icon: "el-icon-s-fold",
						name: "物流设置",
						pathname:'set_express'
					},
					{
						icon: "el-icon-s-fold",
						name: "角色管理",
						pathname:'set_manager'
					}
				
				]
			}
		]
	}
}
